export { default } from './isMuiElement';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/isMuiElement/index.js
// module id = 374
// module chunks = 22